const _ = require('underscore');
const analyticsUtilities = require('utilities/analyticsUtilities');
const fireError = analyticsUtilities.fireError;
const uaParser = new (require('ua-parser-js'))();

const browser = uaParser.getBrowser();
const os = uaParser.getOS();

const osName = os.name;
const osVersion = os.version;
const browserName = browser.name;
const browserVersion = browser.version;

let blacklist = [
	{
		// Generic chrome script error
		message: 'Script error.'
	},
	{
		// Generic chrome script error
		message: 'Script error'
	},
	{
		// empty case
		message: '{}'
	},
	{
		// Ignore chrome extention errors
		message: /chrome-extension:\/\//
	},
	{
		// Previous TrackJS Config
		message: /NS_ERROR_NOT_INITIALIZED|401 Unauthorized|409 Conflict/i
	},
	{
		// https://stackoverflow.com/questions/5163831/uiwebview-enabling-action-sheets-on-img-tags ???
		// iOS UIWebView with copy+paste stack overflow code?
		message: /Can\'t find variable: MyAppGet/
	},
	{
		message: 'ResizeObserver loop limit exceeded'
	}
];

const isBlacklisted = error => {
	return blacklist.some(b => {
		for (let property in b) {
			let criteria = b[property];
			let errorProperty = error[property];

			if (typeof errorProperty !== 'undefined') {
				if (typeof criteria === 'string') {
					criteria = criteria.trim();
				}
				if (criteria instanceof RegExp && criteria.test(errorProperty)) {
					return true;
				} else if (criteria === errorProperty) {
					return true;
				}
			}
		}
		return false;
	});
};

const logErrors = event => {
	if (!event) {
		return;
	}

	let data = {
		osName,
		osVersion,
		browserName,
		browserVersion
	};
	let name = 'UNCAUGHT_ERROR';
	let message = undefined;
	let stack = undefined;

	if (event.type === 'unhandledrejection') {
		if (event.message) {
			message = event.message;
		} else if (event.reason) {
			message = event.reason.message;
		}
		if (event.stack) {
			stack = event.stack;
		} else if (event.reason) {
			stack = event.reason.stack;
		}
		if (!message) {
			return;
		}
		name = 'UNHANDLED_REJECTION';
		data = _.assign(data, {
			message,
			stack
		});
	} else {
		message = event.message;
		stack = event.stack;
		let filename = event.filename;
		let lineno = event.lineno;
		let colno = event.colno;
		let error = event.error;

		data = _.assign(data, {
			message,
			filename,
			lineno,
			colno,
			stack,
			error
		});
	}

	if (!isBlacklisted(data)) {
		fireError(name, data);
	}
};

window.addEventListener('error', logErrors);
window.addEventListener('unhandledrejection', logErrors);

module.exports = {};
